export const ActionTypes = {
  SYSTEM_REAL_TIME_COMMS_SET_STATUS_SUCCESS:
    "SYSTEM_REAL_TIME_COMMS_SET_STATUS_SUCCESS",

  SYSTEM_REAL_TIME_COMMS_INIT_SIGNALR: "SYSTEM_REAL_TIME_COMMS_INIT_SIGNALR",
};
